<div id="wrapper">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>
  <div>
    <app-tab-nav></app-tab-nav>
  </div>
  <div class="allcont logsize m-top-i">
    <div class="basicrow ">
      <div class="container">
        <div class="basicr-line-i">
          <div class="fulltitle  f-btitle autodef">
            <span class="icon-dash-27"></span> Lista de Canales
          </div>
        </div>
      </div>
      <div class="allcont logsize ">
        <div class="container">
          <div class="basicr-line-i m-top-i">
            <div class="autodef ">
              Guia de Canales
            </div>
          </div>
          <div class="basicrow m-top-i mbott tab-m-bot">
            <div class="difftabs">
              <div (click)="this.changeTab(1);"
                [className]="this.session===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Todos
              </div>

              <div (click)="this.changeTab(2);"
                [className]="this.session===2 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Basicos
              </div>

              <div (click)="this.changeTab(3);"
                [className]="this.session===3 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Premium
              </div>

              <div (click)="this.changeTab(4);"
                [className]="this.session===4 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Adultos
              </div>
            </div>
          </div>
          <div class="allcont logsize ">
            <div class="basicrow roboto-r f-reg f-black m-bott">
              <div class="padding-bottom">
                <app-collapse-iptv [plan]="this.session" [chanels]="this.chanelList" [(category)]="this.category">
                </app-collapse-iptv>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
